import router from '../router';

export const redirectToLogin = () => {
  router.push('/login');
};